import { Component } from '@angular/core';

// original stroke width: 0.123274

@Component({
	moduleId: module.id,
	selector: 'cropmanage-logo',
	template: `
<svg
   version="1.1"
   id="svg847"
   width="425.33334"
   height="78.666664"
   viewBox="0 0 425.33334 78.666664">
  <g
     inkscape:groupmode="layer"
     inkscape:label="Image"
     id="g855">
    <path
       id="path873"
       style="display:inline;fill-opacity:1;
	   stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       inkscape:label="leaf"
       d="m 43.048736,46.493398 c -0.256317,-1.47879 -0.06954,-3.893475 -0.711223,
	   -6.216422 -2.068848,-0.06572 -5.872421,-2.385535 -8.287985,-4.634691 -3.839017,
	   -3.574546 -3.340912,-10.624634 -3.509993,-14.276642 -0.05814,-1.255888 0.88532,
	   -1.422791 1.386917,-1.462099 3.468579,-0.271823 9.553632,2.893413 11.828314,
	   7.37176 1.891768,3.724473 1.9712,6.891714 1.659958,11.853878 -1.922381,
	   -4.107752 -3.414976,-6.870466 -5.729639,-9.900492 -0.867371,-1.135438 -2.099358,
	   -2.554213 -3.014778,-3.047143 -0.626661,-0.33744 2.30399,3.146892 3.247068,
	   4.847908 1.433748,2.586031 3.115104,5.18067 3.635738,8.091363 0.43372,
	   2.424787 -0.504377,7.37258 -0.504377,7.37258 z m 1.124169,5.638589 c 0.557136,
	   -1.790793 4.735654,-9.630488 7.600924,-12.058009 4.496881,-0.07959 11.293884,
	   0.966485 15.679391,-1.949975 7.322024,-4.869309 12.019358,-10.938607 13.251872,
	   -20.614023 0.193457,-1.518669 0.411152,-2.494044 -0.679128,-2.541646 -7.539358,
	   -0.329174 -17.703337,0.05086 -24.153208,5.168143 -4.755522,3.773002 -8.436627,
	   10.466194 -7.760105,16.4753 4.178518,-4.974426 6.75617,-7.876535 10.983533,
	   -10.784556 3.232647,-2.223751 8.715195,-4.297904 10.704966,-4.894835 1.36212,
	   -0.408635 -6.151275,3.837962 -8.874377,6.208084 -4.835639,4.208823 -10.545784,
	   9.630489 -13.09269,14.087575 -1.528475,2.674832 -3.661178,10.903942 -3.661178,
	   10.903942 z M 36.223225,0.92493272 C 21.077681,3.588561 9.863512,
	   16.662515 9.8632812,32.662109 9.862461,50.622806 24.422115,65.183335 42.382812,
	   65.183594 c 2.639976,-3.8e-5 5.206472,-0.31465 7.664051,-0.908396 6.494405,
	   -1.569034 12.2282,-5.087357 16.547399,-9.900944 C 68.225139,52.039507 68.566387,
	   51.3485 69.15006,48.692159 63.78579,56.085964 55.07553,60.89439 45.242188,
	   60.894531 28.940176,60.894298 15.724842,47.678965 15.724609,31.376953 15.723763,
	   15.074178 28.939413,1.8576544 45.242188,1.8574219 42.367311,0.87188762 40.60593,
	   0.41666946 36.223225,0.92493272 Z M 46.509766,5.0039062 C 32.15402,5.1318985 20.583851,
	   16.805792 20.583984,31.162109 c 4.4e-4,14.446595 11.735513,25.327481 26.158204,
	   26.158203 4.548525,0.261987 6.118327,-1.059626 8.768726,-2.517491 -1.677264,
	   0.449457 -4.918752,0.945203 -6.409352,0.945226 C 35.878042,55.747969 25.158281,
	   45.028208 25.158203,31.804688 25.158281,18.581168 35.878042,7.8614065 49.101562,
	   7.8613281 53.95365,7.8616537 60.161318,10.032329 64.763499,13.065213 63.975271,
	   11.27538 60.871186,9.2629447 58.982762,8.042462 55.313528,6.0970585 51.140124,
	   5.0040445 46.742188,5.0039062 c -0.07747,-3.442e-4 -0.154948,-3.442e-4 -0.232422,
	   0 z M 419.3286,42.287714 q -0.384,-2.304 -1.488,-3.984 -1.056,-1.728 -2.496,
	   -2.832 -1.44,-1.104 -3.072,-1.632 -1.632,-0.528 -3.216,-0.528 -1.536,0 -3.216,
	   0.528 -1.632,0.528 -3.072,1.632 -1.44,1.104 -2.544,2.832 -1.056,1.68 -1.392,
	   3.984 z m -20.496,3.024 q 0.096,1.92 0.96,3.648 0.864,1.728 2.256,3.024 1.44,
	   1.296 3.216,2.064 1.824,0.768 3.744,0.768 1.776,-0.048 3.312,-0.528 1.536,
	   -0.528 2.736,-1.344 1.2,-0.864 2.064,-1.968 0.864,-1.104 1.296,-2.352 h 3.552 q -0.672,
	   1.968 -1.92,3.648 -1.248,1.68 -2.976,2.928 -1.68,1.248 -3.744,1.968 -2.016,
	   0.672 -4.272,0.672 -2.736,0 -5.232,-1.056 -2.496,-1.056 -4.368,-2.88 -1.872,
	   -1.872 -2.976,-4.368 -1.104,-2.496 -1.104,-5.424 0,-2.784 1.056,-5.28 1.056,
	   -2.496 2.88,-4.368 1.872,-1.872 4.32,-2.976 2.496,-1.152 5.376,-1.2 2.16,
	   0 3.984,0.624 1.872,0.576 3.312,1.536 1.488,0.96 2.592,2.16 1.104,1.2 1.824,
	   2.4 1.152,1.872 1.584,3.744 0.48,1.872 0.48,3.6 0,0.24 -0.048,0.48 0,0.24 0,
	   0.48 z m -33.32793,-1.2 q 0,2.16 0.768,4.08 0.816,1.92 2.16,3.408 1.392,
	   1.488 3.264,2.352 1.92,0.864 4.176,0.864 2.592,0 4.56,-1.056 1.968,-1.056 3.264,
	   -2.64 1.296,-1.584 1.92,-3.456 0.672,-1.872 0.672,-3.552 0,-2.16 -0.816,
	   -4.128 -0.768,-1.968 -2.208,-3.408 -1.392,-1.488 -3.312,-2.352 -1.872,-0.912 -4.08,
	   -0.912 -2.256,0 -4.176,0.912 -1.872,0.864 -3.264,2.352 -1.344,1.44 -2.16,
	   3.408 -0.768,1.968 -0.768,4.128 z m 23.952,8.976 q 0,1.056 -0.048,2.256 -0.048,
	   1.152 -0.288,2.4 -0.192,1.248 -0.672,2.496 -0.48,1.248 -1.392,2.448 -1.248,
	   1.728 -2.88,2.688 -1.632,1.008 -3.168,1.44 -1.536,0.48 -2.784,0.576 -1.2,
	   0.144 -1.584,0.144 -1.392,0 -3.36,-0.384 -1.92,-0.336 -3.888,-1.392 -1.92,
	   -1.008 -3.6,-2.928 -1.68,-1.872 -2.592,-4.944 h 3.552 q 0.336,0.816 1.008,
	   1.92 0.672,1.152 1.824,2.208 1.2,1.056 2.88,1.776 1.728,0.72 4.128,0.72 1.632,
	   0 3.312,-0.528 1.728,-0.48 3.072,-1.632 1.392,-1.152 2.256,-3.024 0.864,
	   -1.872 0.864,-4.608 v -2.304 h -0.096 q -0.72,1.392 -1.872,2.448 -1.152,
	   1.008 -2.496,1.68 -1.344,0.672 -2.832,0.96 -1.488,0.336 -2.928,0.336 -2.592,
	   0 -5.088,-0.96 -2.448,-0.96 -4.368,-2.736 -1.92,-1.824 -3.12,-4.32 -1.152,
	   -2.496 -1.152,-5.616 0,-3.12 1.152,-5.664 1.2,-2.592 3.12,-4.416 1.92,-1.824 4.368,
	   -2.832 2.496,-1.008 5.088,-1.008 0.912,0 2.16,0.192 1.296,0.192 2.688,0.768 1.392,
	   0.576 2.736,1.632 1.392,1.056 2.544,2.784 h 0.096 v -4.704 h 3.36 z m -57.37594,
	   -8.928 q 0,2.208 0.768,4.176 0.768,1.92 2.16,3.36 1.44,1.44 3.408,2.304 2.016,
	   0.816 4.416,0.816 2.112,0 4.032,-0.816 1.92,-0.816 3.36,-2.208 1.44,-1.44 2.256,
	   -3.408 0.864,-1.968 0.864,-4.272 0,-2.16 -0.816,-4.128 -0.768,-1.968 -2.208,
	   -3.408 -1.392,-1.488 -3.312,-2.352 -1.92,-0.912 -4.176,-0.912 -2.16,0 -4.128,
	   0.768 -1.92,0.768 -3.408,2.16 -1.488,1.392 -2.352,3.408 -0.864,2.016 -0.864,
	   4.512 z m 24.432,13.056 h -3.36 v -4.608 h -0.096 q -1.104,1.632 -2.448,2.64 -1.344,
	   1.008 -2.736,1.584 -1.392,0.576 -2.736,0.768 -1.296,0.24 -2.304,0.24 -3.12,
	   0 -5.712,-1.104 -2.592,-1.104 -4.464,-2.976 -1.872,-1.872 -2.928,-4.368 -1.008,
	   -2.544 -1.008,-5.376 0,-2.64 1.008,-5.088 1.008,-2.496 2.832,-4.416 1.824,
	   -1.92 4.416,-3.072 2.64,-1.152 5.856,-1.152 1.056,0 2.4,0.24 1.344,0.192 2.736,
	   0.768 1.392,0.576 2.688,1.632 1.344,1.008 2.4,2.64 h 0.096 v -4.608 h 3.36 z m -56.84795,
	   -26.256 h 3.36 v 3.36 h 0.096 q 0.384,-0.576 1.056,-1.296 0.672,-0.72 1.68,
	   -1.296 1.008,-0.624 2.304,-1.008 1.344,-0.432 3.024,-0.432 2.448,0 4.464,0.72 2.016,
	   0.672 3.84,2.496 1.488,1.44 2.352,3.744 0.912,2.256 0.912,5.52 v 14.448 h -3.36 v -14.448 q 0,
	   -2.592 -0.72,-4.368 -0.672,-1.776 -1.776,-2.832 -1.392,-1.344 -3.024,-1.776 -1.584,
	   -0.48 -2.688,-0.48 -1.104,0 -2.736,0.48 -1.584,0.432 -2.976,1.776 -1.056,
	   1.008 -1.776,2.784 -0.672,1.728 -0.672,4.176 v 14.688 h -3.36 z m -31.40794,13.2 q 0,
	   2.208 0.768,4.176 0.768,1.92 2.16,3.36 1.44,1.44 3.408,2.304 2.016,0.816 4.416,
	   0.816 2.112,0 4.032,-0.816 1.92,-0.816 3.36,-2.208 1.44,-1.44 2.256,-3.408 0.864,
	   -1.968 0.864,-4.272 0,-2.16 -0.816,-4.128 -0.768,-1.968 -2.208,-3.408 -1.392,
	   -1.488 -3.312,-2.352 -1.92,-0.912 -4.176,-0.912 -2.16,0 -4.128,0.768 -1.92,
	   0.768 -3.408,2.16 -1.488,1.392 -2.352,3.408 -0.864,2.016 -0.864,4.512 z m 24.432,
	   13.056 h -3.36 v -4.608 h -0.096 q -1.104,1.632 -2.448,2.64 -1.344,1.008 -2.736,
	   1.584 -1.392,0.576 -2.736,0.768 -1.296,0.24 -2.304,0.24 -3.12,0 -5.712,-1.104 -2.592,
	   -1.104 -4.464,-2.976 -1.872,-1.872 -2.928,-4.368 -1.008,-2.544 -1.008,-5.376 0,
	   -2.64 1.008,-5.088 1.008,-2.496 2.832,-4.416 1.824,-1.92 4.416,-3.072 2.64,
	   -1.152 5.856,-1.152 1.056,0 2.4,0.24 1.344,0.192 2.736,0.768 1.392,0.576 2.688,
	   1.632 1.344,1.008 2.4,2.64 h 0.096 v -4.608 h 3.36 z m -71.15193,-35.52 h 5.472 l 12.912,
	   30.24 12.96,-30.24 h 5.472 v 35.52 h -3.552 v -31.632 h -0.096 l -13.296,
	   31.632 h -3.024 l -13.2,-31.632 h -0.096 v 31.632 h -3.552 z m -9.75996,22.464 q 0,
	   -2.496 -0.864,-4.512 -0.864,-2.016 -2.352,-3.408 -1.488,-1.392 -3.456,-2.16 -1.92,
	   -0.768 -4.08,-0.768 -2.256,0 -4.224,0.912 -1.92,0.864 -3.312,2.352 -1.392,
	   1.44 -2.208,3.408 -0.768,1.968 -0.768,4.128 0,2.304 0.816,4.272 0.864,1.968 2.304,
	   3.408 1.44,1.392 3.36,2.208 1.92,0.816 4.032,0.816 2.4,0 4.368,-0.816 2.016,
	   -0.864 3.408,-2.304 1.44,-1.44 2.208,-3.36 0.768,-1.968 0.768,-4.176 z m -24.432,
	   -13.2 h 3.36 v 4.608 h 0.096 q 1.152,-1.632 2.448,-2.64 1.344,-1.056 2.688,-1.632 1.392,
	   -0.576 2.688,-0.768 1.344,-0.24 2.4,-0.24 3.216,0 5.808,1.152 2.64,1.152 4.464,3.072 1.824,
	   1.92 2.832,4.416 1.008,2.448 1.008,5.088 0,2.832 -1.056,5.376 -1.056,2.496 -2.928,
	   4.368 -1.872,1.872 -4.464,2.976 -2.592,1.104 -5.664,1.104 -1.008,0 -2.352,-0.24 -1.296,
	   -0.192 -2.688,-0.768 -1.392,-0.576 -2.736,-1.584 -1.344,-1.056 -2.448,
	   -2.64 h -0.096 v 13.824 h -3.36 z m -30.01594,13.248 q 0,2.304 0.864,4.272 0.864,
	   1.92 2.304,3.36 1.44,1.392 3.312,2.208 1.872,0.768 3.888,0.768 1.92,0 3.744,-0.72 1.872,
	   -0.768 3.312,-2.16 1.488,-1.392 2.4,-3.408 0.912,-2.016 0.912,-4.608 0,-2.592 -1.008,
	   -4.56 -0.96,-2.016 -2.496,-3.312 -1.488,-1.344 -3.36,-2.016 -1.824,-0.72 -3.504,
	   -0.72 -1.824,0 -3.648,0.72 -1.824,0.72 -3.36,2.112 -1.488,1.392 -2.448,3.456 -0.912,
	   2.016 -0.912,4.608 z m -3.36,0.048 q 0,-3.12 1.152,-5.664 1.2,-2.592 3.072,-4.416 1.92,
	   -1.872 4.368,-2.88 2.496,-1.008 5.088,-1.008 2.928,0 5.424,1.152 2.544,1.152 4.368,
	   3.072 1.872,1.872 2.928,4.368 1.056,2.496 1.056,5.184 0,2.688 -1.056,5.184 -1.056,
	   2.496 -2.88,4.416 -1.824,1.872 -4.368,3.024 -2.544,1.152 -5.472,1.152 -2.88,0 -5.376,
	   -1.104 -2.496,-1.152 -4.368,-3.024 -1.824,-1.872 -2.88,-4.32 -1.056,-2.448 -1.056,
	   -5.136 z m -14.03186,-13.296 h 3.36 v 3.792 h 0.096 q 0.576,-1.392 1.392,-2.208 0.864,
	   -0.864 1.824,-1.344 0.96,-0.48 2.016,-0.624 1.104,-0.192 2.16,-0.288 v 3.552 q -1.776,
	   0.144 -3.264,0.816 -1.44,0.624 -2.4,1.776 -0.864,1.104 -1.344,2.496 -0.48,1.344 -0.48,
	   2.928 v 15.36 h -3.36 z m -6.01599,16.944 q -1.44,2.592 -3.36,4.512 -1.92,1.872 -4.128,
	   3.072 -2.16,1.2 -4.464,1.776 -2.256,0.576 -4.416,0.576 -3.744,0 -7.104,-1.392 -3.36,
	   -1.392 -5.904,-3.84 -2.544,-2.448 -4.08,-5.808 -1.487998,-3.36 -1.487998,-7.296 0,
	   -3.936 1.439998,-7.296 1.488,-3.36 3.984,-5.808 2.544,-2.496 5.904,-3.888 3.408,
	   -1.392 7.2,-1.392 3.408,0 6.192,1.056 2.784,1.056 4.848,2.592 2.064,1.488 3.36,
	   3.168 1.344,1.632 1.872,2.88 h -3.984 q -1.44,-2.16 -3.264,-3.456 -1.824,-1.296 -3.552,
	   -1.968 -1.728,-0.672 -3.216,-0.864 -1.488,-0.192 -2.304,-0.192 -3.12,0 -5.856,1.296 -2.688,
	   1.248 -4.704,3.36 -2.016,2.112 -3.216,4.848 -1.152,2.736 -1.152,5.712 0,3.12 1.248,
	   5.856 1.248,2.736 3.312,4.8 2.112,2.064 4.8,3.264 2.736,1.152 5.616,1.152 0.672,0 2.016,
	   -0.144 1.344,-0.144 3.024,-0.768 1.728,-0.672 3.648,-2.016 1.92,-1.344 3.744,
	   -3.792 z M 21.136719,3.1113281 A 39.250275,39.250275 0 0 0 1.2753906,37.236328 39.250275,
	   39.250275 0 0 0 40.525391,76.488281 39.250275,39.250275 0 0 0 79.775391,37.236328 39.250275,
	   39.250275 0 0 0 79.638672,33.962891 37.046268,37.046268 0 0 1 42.597656,70.353516 37.046268,
	   37.046268 0 0 1 5.5507812,33.306641 37.046268,37.046268 0 0 1 21.136719,3.1113281 Z" />
  </g>
</svg>


	`,
})

export class SVGLogoComponent {

}


